import React, { Component } from 'react';
import { connect} from 'react-redux';
import logo from './logo.svg';
import Menu from './containers/Menu';
import Logout from './containers/Logout';
import LogIn from './pages/login';
import Members from './pages/members';
import Study from './pages/study';
import Dashboards from './pages/dashboard'
import StudyLists from './pages/study/studyLists';
import Payment from './pages/Payment'
import Home from './pages/Home';
import Coupon from './pages/Coupon'
import Counrty from './pages/country';
import { BrowserRouter as Router , Route, Switch }  from 'react-router-dom';
import DemographicsCategories from './pages/demographics';
import AddDemographicsCategories from './pages/demographics/addDemoCategory';
import EditDemographicsCategories from './pages/demographics/editDemoCategory';
import AddDemographicsCategoriesQuestion from './pages/demographics/addDemoCatQuestion';
import EditDemographicsQuestions from './pages/demographics/editDemoCatQuestion';
import AddDemoOption from './pages/demographics/addDemoOption';
import DemographicsSubQuestions from './pages/demographics/demoSubquestion';
import AddDemographicsSubQuestion from './pages/demographics/addDemoSubQuestion';
import EditDemographicsSubQuestion from './pages/demographics/editDemoSubQuestion';
import AddDemoSubOption from './pages/demographics/addSubOption';
import EditDemographicsSubOption from './pages/demographics/editSubOption';
import DemographicsSecondSubQuestions from './pages/demographics/demoSecSubquestion'
import AddDemographicsSecSubQuestion from './pages/demographics/addDemoSecSubQuestion';
import EditDemographicsSecSubQuestion from './pages/demographics/editDemoSecSubQuestion';
import AddDemoSecSubOption from './pages/demographics/addSecSubOption';
import EditDemographicsSecSubOption from './pages/demographics/editSecSubOption';
import UserDemographicsCategories from './pages/country/userDemographic';
import UserDemographicsData from './pages/country/userDemographicsData';
import ChangePassword from './pages/changePassword/index';
import './App.css';

class App extends Component {

  
  render() {

    let viewHtml = ""
    if(this.props.authenticated === undefined || this.props.authenticated === false){
     
    let adminToken = sessionStorage.getItem('adminToken');
    
    if(adminToken){ 

      viewHtml = 
      <div className="back">
      <header>
        
        <h1> GNN ADMIN PANEL  </h1>
       
      </header>
      <div >
          <Router>
            <div className = "row">
              <div className = "menuCol">
              <Menu />
              </div>
              <div className = "pageCol">
              <Route component={Dashboards} exact path="/" />
              <Switch> 
              <Route path="/logout" component={Logout}/>
              <Route path="/members" component={Members} />
              <Route path="/Study" component={Study} />
              <Route path="/dashboard" component={Dashboards} />
              <Route path="/studyList" component={StudyLists} />
              <Route path="/home" component={Home} />    
              <Route path="/payment" component={Payment} />     
              <Route path="/coupon" component={Coupon} /> 
              <Route path="/counrty" component={Counrty} />     
              <Route path="/demographicsCategories" component={DemographicsCategories} />        
              <Route path="/addDemographicsCategories" component={AddDemographicsCategories} /> 
              <Route path="/editDemographicsCategories" component={EditDemographicsCategories} />        
              <Route path="/addDemoCatQues/:key" component={AddDemographicsCategoriesQuestion} />
              <Route path="/editDemographicsQuestions" component={EditDemographicsQuestions} />
              <Route path="/demoOption/:key" component={AddDemoOption} />
              <Route path="/demoSubQuestion/:key" component={DemographicsSubQuestions} />
              <Route path="/subQuestion/:key" component={AddDemographicsSubQuestion} />
              <Route path="/editSubQuestion/:key" component={EditDemographicsSubQuestion} />
              <Route path="/demoAddSubOption/:key" component={AddDemoSubOption} />
              <Route path="/editSubOption/:key" component={EditDemographicsSubOption} />
              <Route path="/demoSecSubQuestion/:key" component={DemographicsSecondSubQuestions} />
              <Route path="/demoAddSecSubQuestion/:key" component={AddDemographicsSecSubQuestion} />
              <Route path="/demoUpdateSecSubQuestion/:key" component={EditDemographicsSecSubQuestion} />
              <Route path="/demoAddSecSubOption/:key" component={AddDemoSecSubOption} />
              <Route path="/demoEditSecSubOption/:key" component={EditDemographicsSecSubOption} />
              <Route path="/UserDemographicsCategories/:key" component={UserDemographicsCategories} />
              <Route path="/UserDemographicsDetails/:key" component={UserDemographicsData} />
              <Route path="/changePassword" component={ChangePassword} />

              </Switch>
            </div>
            </div>
          </Router>
          </div>
       </div>
    }else{
      viewHtml = 
    <Router><div>
      <div> 
     
      <Switch>
      <Route component={LogIn} exact path="/" />
      <Route component={LogIn} exact path="/login" />
      </Switch>
      </div></div>
    </Router>
    }

    }else{

    viewHtml = 
    <div className="back">
      <header>
        <h1> GNN ADMIN PANEL  </h1>
       
      </header>
      <div >
          <Router>
            <div className = "row">
              <div className = "menuCol">
              <Menu />
              </div>
              <div className = "pageCol">
              <Route component={Dashboards} exact path="/" />
              <Switch>
              <Route component={Logout} path="/logout" />
              <Route component={Members} exact path="/members" />
              <Route component={Study} exact path="/study" />
              <Route component={Dashboards} exact path="/dashboard" />
              <Route component={StudyLists} exact path="/studyList" />
              <Route component={Home} exact path="/home" />
              <Route path="/payment" component={Payment} /> 
              <Route path="/coupon" component={Coupon} /> 
              <Route path="/counrty" component={Counrty} />       
              <Route path="/demographicsCategories" component={DemographicsCategories} />  
              <Route path="/addDemographicsCategories" component={AddDemographicsCategories} />     
              <Route path="/editDemographicsCategories" component={EditDemographicsCategories} />  
              <Route path="/addDemoCatQues/:key" component={AddDemographicsCategoriesQuestion} />
              <Route path="/editDemographicsQuestions" component={EditDemographicsQuestions} /> 
              <Route path="/demoOption/:key" component={AddDemoOption} />       
              <Route path="/demoSubQuestion/:key" component={DemographicsSubQuestions} /> 
              <Route path="/subQuestion/:key" component={AddDemographicsSubQuestion} />
              <Route path="/editSubQuestion/:key" component={EditDemographicsSubQuestion} />
              <Route path="/demoAddSubOption/:key" component={AddDemoSubOption} />
              <Route path="/editSubOption/:key" component={EditDemographicsSubOption} />
              <Route path="/demoSecSubQuestion/:key" component={DemographicsSecondSubQuestions} />
              <Route path="/demoAddSecSubQuestion/:key" component={AddDemographicsSecSubQuestion} />
              <Route path="/demoUpdateSecSubQuestion/:key" component={EditDemographicsSecSubQuestion} />
              <Route path="/demoAddSecSubOption/:key" component={AddDemoSecSubOption} />
              <Route path="/demoEditSecSubOption/:key" component={EditDemographicsSecSubOption} />
              <Route path="/UserDemographicsCategories/:key" component={UserDemographicsCategories} />
              <Route path="/UserDemographicsDetails/:key" component={UserDemographicsData} />
                <Route path="/changePassword" component={ChangePassword} />
              </Switch>
            </div>
            </div>
          </Router>
          </div>
       </div>
    }
    return (
      <div className="back">
     {viewHtml}
      </div>
    );
  }
}


const mapStateToProps =(state) =>{
    return {
      authenticated : state.login.authenticated,
    }
  }
  
  export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js